// @react
import React, { ReactElement, ReactNode, ReactNodeArray } from 'react'
// @types
import { GetUserQuery, GetUserQueryVariables } from 'lib/graphql/graphqlTypes'
// @apollo
import { useQuery } from '@apollo/client'
import { GET_USER } from 'graphql/queries/user.query'
// @libraries
import { makeStyles, Theme } from '@material-ui/core/styles'
import { useMediaQuery } from '@material-ui/core'
// @common
import config from 'constants/config'
// @components
import theme from '@bit/atd.web.theme'
import Container from '@bit/atd.web.container'
import Grid from '@bit/atd.web.grid'
// @module components
import { routes as profileRoutes } from 'modules/profile'
import SectionMenuWrapper from 'modules/common/components/SectionMenuWrapper'

/**
 * 4.0.4 My ATD - Activity History - User Content
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=2507%3A7294
 */

export const useStyles = makeStyles((theme: Theme) => ({
  layout: {
    paddingTop: '24px',
    paddingBottom: '8px',
    [theme.breakpoints.up('md')]: {
      paddingTop: '32px',
      paddingBottom: '16px',
    },
  },
}))

type PropsType = {
  children: ReactNode | ReactNodeArray
}

const ActivityHistory = (props: PropsType): ReactElement => {
  /******************************************
   * PROPS
   ******************************************/

  const { children } = props

  /******************************************
   * HOOKS
   ******************************************/

  const classes = useStyles()

  /******************************************
   * GQL HOOKS
   ******************************************/

  const { data } = useQuery<GetUserQuery, GetUserQueryVariables>(GET_USER, {
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  })

  /******************************************
   * HOOKS
   ******************************************/
  const isMobile = useMediaQuery(
    theme.breakpoints.down('sm'),
    config.mediaQuery,
  )

  /******************************************
   * FUNCTIONS
   ******************************************/

  return (
    <>
      {isMobile && <SectionMenuWrapper routeGroup={profileRoutes} />}

      <Container className={classes.layout}>
        <Grid container spacing={4}>
          {!isMobile && (
            <Grid item xs={12} md={3}>
              <SectionMenuWrapper
                user={data?.user}
                routeGroup={profileRoutes}
              />
            </Grid>
          )}

          <Grid item xs={12} md={9}>
            {children}
          </Grid>
        </Grid>
      </Container>
    </>
  )
}

export default ActivityHistory
